import { type CountryCode, validatePhoneNumberLength } from "libphonenumber-js";

/**
 * Decides which digits a phone-input change event should settle on.
 *
 * The rule is deliberately one-sided: digits the visitor supplied are never
 * removed on their behalf. Trimming the tail hands back a different number
 * than the one they can see, which is exactly how a verification code could be
 * sent to a number the visitor never entered (ENG-2997).
 *
 * The single exception is a keystroke that would push a within-limit number
 * past the country's maximum. That digit is refused outright, so nothing is
 * ever accepted and then dropped. An over-long paste is kept intact and left
 * to fail validation, where the inline error can explain it.
 *
 * Lives apart from PhoneInput.tsx so the rule can be tested without a DOM.
 */
export function resolveDigits(previous: string, next: string, dialCode: string, country: CountryCode): string {
  const tooLong = (digits: string): boolean => validatePhoneNumberLength(dialCode + digits, country) === "TOO_LONG";
  const isSingleKeystroke = next.length === previous.length + 1;
  if (isSingleKeystroke && !tooLong(previous) && tooLong(next)) return previous;
  return next;
}
